<template>
	<div class="wrapbox">
		<div class="home_box" >
			<el-carousel indicator-position="none" arrow="always">
		        <el-carousel-item v-for="(item,index) in banner" :key='index'>
					<div :style="'width: 100%;height: 100%;background:url('+apiUrl+item.vc_coverphoto+') no-repeat center'" class="back">
					
					</div>
		<!--              <img class="homebannerbg" :src="apiUrl+item.vc_coverphoto" ref="image" >-->
		        </el-carousel-item>
			</el-carousel>
			<!--通知-->
			<!--<rolling ref='rolling'></rolling>-->
			<div class="introduce">
				
				<h2>ByteV中台</h2>
				<br>
				<h4>挖掘数据价值，赋能企业决策</h4>
				
			</div>
			<a href="http://bytev-beta.bytev.cn/" target="_blank"><div class="to_m">基础版体验</div></a>
			<a href="http://console.bytev.cn" target="_blank"><div class="to_use">立即使用</div></a>
			<!--<img id='homepage_download' @click="downLoad" style="cursor: pointer;" src="../assets/images/down.png" />-->
		</div>
		<div class="contentbox1">
			<div class="box1">
				<div class="navlogo">
					<img src="../assets/images/nav1.png"/>
					<h4>云平台集成</h4>
					<p>与云计算伙伴进行深度合作打造云化版本，使 ByteV在云计算平台上的运行效率达到最优化。</p>
					<p></p>
				</div>
				<div class="navlogo">
					<img src="../assets/images/nav2.png"/>
					<h4>能力集成</h4>
					<p>通过能力集成，平台具备机器翻译能力、GIS 平台与模型对接能力以及海量的数据资源库。</p>
					<p></p>
				</div>
				<div class="navlogo">
					<img src="../assets/images/nav3.png"/>
					<h4>离线部署</h4>
					<p>ByteV平台根据用户的实际需求以及现场的环境情况和性能要求，提供三种部署模式， 包括单机部署、集群部署以及云部署/虚拟机部署。</p>
					<p></p>
				</div>
			</div>
		</div>
		<div id="testid" class="contentbox2">
			<div class="box2">
				<h3>实例:各领域数据智能的最佳实践</h3>
				<div  class="demobox">
					
				</div>
				<ul>
					<li>基于庞大的素材库支撑</li>
					<li>多样化的炫酷图表样式</li>
					<li>便捷化的拖拽构建方式</li>
					<li>支持多种接口数据对接</li>
					<li>直接嵌入自由开发系统</li>
					<li>有效缩短产品研发周期</li>
				</ul>
			</div>
			<!-- <div @click="jumpdemo" class="knowmorebg">
				了解更多
			</div> -->
			<!--<img src="../assets/images/knowmore.png"/>-->	
		</div>
		<div class="contentbox3">
			<div class="box3">
				<div class="left">
					<el-carousel indicator-position="none" :interval="4000" type="card">
			<el-carousel-item>
				<img src="../assets/images/graphswiper1.png"/>
			</el-carousel-item>
			<el-carousel-item>
				<img src="../assets/images/graphswiper2.png"/>
			</el-carousel-item>
			<el-carousel-item> 
				<img src="../assets/images/graphswiper3.png"/>
			</el-carousel-item>
			<el-carousel-item> 
				<img src="../assets/images/graphswiper4.png"/>
			</el-carousel-item>
		</el-carousel>
				</div>
				<div class="right">
					<h3>使用的场景及人群：</h3>
					<!--<ul>
						<li>覆盖金融、医疗、科技等不同行业</li>
						<li>业界领袖、学术科研专家精心打磨</li>
						<li>支持依托应用案例绘制可视化图谱</li>
					</ul>-->
					<p style="text-indent:24px;text-align: left;">ByteV中台可满足不同行业客 户在决策支持、趋势预测、公共安全、事件监 测、业务管控、风险预警、地理分析等多个业务领域的可视化分析需求。</p>
					<div @click="jumpgrah" class="knowmorebg">
						了解更多
					</div>
					<!--<img class="knowmorebg" src="../assets/images/knowmore.png"/>-->
				</div>
			</div>
		</div>
		<div class="contentbox4">
			<div class="box4">
				<div class="fourtop">
					<div class="left">
						<!--<h3>知识库</h3>-->
					<ul>
						<li>产品能力：提供高效便捷、所见即所得的可视化开发环境。</li>
						<li>技术能力：提供全过程、定制化的大数据产品+定制服务。</li>
						<li>服务能力：提供包括规划、咨询、设计、 开发、实施、运维和培训的全流程服务。</li>
						<!--<li>快捷的跨语言语义检索与分析</li>-->
					</ul>
					<!-- <div @click="jumprepository" class="knowmorebg">
						了解更多
					</div> -->
					</div>
					<div class="right">
						
					</div>
				</div>
				<div class="bottomnavbox">
					<div class="navlogo">
						<div class="logobottom">
							<!--<img src="../assets/images/askcircle.png"/>-->
							<img src="../assets/images/home-4-1.png"/>
						</div>
						<h4>海量资源下载</h4>
						<p>丰富的组件库及模板库任意下载</p>
						<!--<p>用户可对实例、应用案例、知识库提问，或加入技术交流QQ群:747279799，我们会第一时间为您解答。</p>-->
						<img style="cursor: pointer;" @click="jumphelp('1')" src="../assets/images/ask.png" />
					</div>
					<div class="navlogo">
						<div class="logobottom">
							<!--<img src="../assets/images/helpcircle.png"/>-->
							<img src="../assets/images/home-4-2.png"/>
						</div>
						<h4>拖拽组件搭建</h4>
						<p>简单快捷的操作方式，轻松搭建专业可视化应用</p>
						<img style="cursor: pointer;" @click="jumphelp('2')" src="../assets/images/ask.png" />
					</div>
					<div class="navlogo">
						<div class="logobottom">
							<!--<img src="../assets/images/downcircle.png"/>-->
							<img src="../assets/images/home-4-3.png"/>
						</div>
						<h4>多种数据源对接</h4>
						<p>支持数据库、API、文件等方式对接</p>
						<img style="cursor: pointer;" @click="jumphelp('2')" src="../assets/images/ask.png" />
					</div>
				</div>
			</div>
		</div>
		<div class="foot_main">
			<div class="foot_mainDiv">
				<div class="foot_mainDiv1">
					<div class="footBorder">
						联系我们
						<span>&nbsp;&nbsp;&nbsp;&nbsp;contact us</span>
					</div>
					<div class="footcontent">北京帮威客科技有限公司</div>
					<div class="footcontent">北京市昌平区郑北路大数据基地1003</div>
					<div class="footcontentimg">
						<div><svg t="1606023827104" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7970" width="5" height="5"><path d="M217.991051 81.67424c28.209737 0 59.713829 16.337189 95.524571 61.182537 99.632274 124.688091 50.632411 159.574309-5.588114 216.169326-39.175314 39.56736 42.8032 139.533166 128.620252 225.8944 70.515566 71.001234 150.264686 139.492206 198.176182 139.492206 10.333623 0 19.180983-3.229989 26.114926-10.216595 32.732891-32.844069 58.151497-63.277349 98.046537-63.277348 28.718811 0 64.927451 15.734491 116.800366 57.689234 123.962514 100.194011 28.75392 167.040731-25.72288 221.874469-15.371703 15.459474-40.983406 23.522743-74.307291 23.522742-102.914926 0-279.399863-77.197897-454.357578-253.208868C89.797954 467.769051 30.253817 231.944777 93.09816 168.679131c34.851109-35.096869 74.617417-87.004891 124.892891-87.004891M205.597725 0C139.985657 0 93.174228 49.27488 55.531988 88.889051c-5.804617 6.097189-11.480503 12.094903-17.045211 17.630355-93.792549 93.815954-17.677166 370.764069 245.151451 633.604388C493.341725 949.669303 695.385702 1024 804.690388 1024c48.37376 0 87.361829-13.382217 112.739474-38.718903 5.61152-5.599817 11.626789-11.340069 17.77664-17.191497 40.790309-38.812526 91.551451-87.086811 88.684252-155.232549-1.96608-46.811429-28.982126-90.527451-82.563657-133.576411-61.012846-49.005714-110.153143-71.80288-154.635703-71.80288-58.022766 0-95.249554 37.677349-128.070217 70.90176l-7.267475 7.337691c-12.41088-1.486263-58.754194-15.775451-177.994605-135.039268-121.417143-121.387886-134.079634-167.614171-135.244069-178.13504l7.168-7.04512c69.216549-68.192549 116.929097-136.531383-0.731428-282.770286C299.776468 27.045303 254.334274 0 205.597725 0z" p-id="7971" fill="#5C5C5C"></path></svg></div>
						<div style="height: 30px;line-height: 30px;">010-89750190</div>
						<div><svg t="1606023796407" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="7034" width="200" height="200"><path d="M538 902l-52 0c-12.667 0-21 2.333-25 7-12.667 12.667-30 22.167-52 28.5s-47.333 9.5-76 9.5c-36.667 0-71-6.333-103-19-4-2-7.833-4.167-11.5-6.5s-6.833-4.5-9.5-6.5-5.167-4.333-7.5-7-4.167-5.167-5.5-7.5-2.333-5-3-8-1-6.167-1-9.5c0-9.333 3.5-17.5 10.5-24.5S221 844.667 237 838c9.333-2.667 15.833-6 19.5-10s5.5-9 5.5-15c0-17.333-2-28-6-32-3.333-4-6.667-9-10-15l-12-16c-3.333-6-6.667-10.667-10-14-6.667-12.667-17.333-19-32-19-4 0-7.5 0.5-10.5 1.5s-6.833 2.833-11.5 5.5-8 4.667-10 6c-12.667 12-21.333 18.333-26 19-7.333 0-11.333-15.333-12-46l0-5c0-21.333 4-57.667 12-109 13.333-38.667 34.667-73 64-103 8.667-8 13-18.667 13-32l0-12c0-19.333 6.333-38.667 19-58 3.333-2.667 5.333-5.5 6-8.5s1-6.5 1-10.5l0-7c0-15.333 1-30.167 3-44.5s5.167-28.167 9.5-41.5 9.833-26.333 16.5-39 14.5-25.167 23.5-37.5 19.167-24.167 30.5-35.5c49.333-55.333 113.333-83 192-83 12.667 0 25 0.667 37 2s23.833 3.5 35.5 6.5 23 6.833 34 11.5 21.667 10 32 16 20.5 13 30.5 21 19.667 16.667 29 26c18 20 33 40 45 60s21.5 41.833 28.5 65.5S794 333.333 794 358l0 7c0 8.667 2 15 6 19 12.667 19.333 19 38.667 19 58l0 12c0 17.333 4.333 28 13 32 30 30 51.333 64.333 64 103 14 43.333 18.333 79.667 13 109 0 15.333-1.5 26.833-4.5 34.5s-7.833 13.167-14.5 16.5c-4.667 0-13.333-6.333-26-19-8.667-8.667-19.333-13-32-13l-12 0c-1.333 0-2.667 0.333-4 1s-2.833 1.167-4.5 1.5-3.167 1.167-4.5 2.5l-4 2-3.5 3.5c0 0-1 1.333-3 4s-2.833 4.167-2.5 4.5c-4.667 12.667-15.333 27.667-32 45-10 10-12.333 20.667-7 32 0 6 5.333 13.333 16 22l3 3c29.333 13.333 44.333 28.333 45 45 0 9.333-3 17.5-9 24.5s-15.667 13.833-29 20.5c-12.667 6-28 10.667-46 14s-37 5-57 5c-53.333 0-96-12.667-128-38 4.667 0 3.667-1.333-3-4L538 902zM685 1024c64 0 115-12.667 153-38 20.667-14 36.5-29.333 47.5-46s16.5-35.667 16.5-57c0-23.333-6.333-44.667-19-64l9 0c2 0 4.833-0.5 8.5-1.5s6.5-2.5 8.5-4.5c36-12 57.333-44 64-96 6-44.667-0.333-96-19-154-2.667-8.667-5.833-17.333-9.5-26s-7.667-17-12-25-9.167-16-14.5-24-10.833-15.667-16.5-23-11.833-15-18.5-23c0-28-6.333-58-19-90 0-32-3.667-62.5-11-91.5s-18.5-56.833-33.5-83.5-34.167-51.667-57.5-75c-10-10-20.333-19.167-31-27.5s-21.5-16-32.5-23-22.333-13.333-34-19S640.833 22 628.5 18 603.667 10.667 591 8s-25.5-4.667-38.5-6S526 0 512 0c-32 0-62.5 3.667-91.5 11S363.667 29.5 337 44.5s-51.667 34.167-75 57.5c-68 76-102 159.333-102 250-12.667 25.333-19 55.333-19 90l0 6c-9.333 7.333-17.833 15.833-25.5 25.5s-14.333 19.667-20 30-10.333 20.167-14 29.5S74 552.333 70 563c-18.667 58-25 109.333-19 154 3.333 24.667 10.667 45.167 22 61.5s25.333 27.833 42 34.5c2 0 6.333 1 13 3s11 3 13 3c-12.667 19.333-19 40.667-19 64 0 44 21.333 78.333 64 103 9.333 6 19.5 11.5 30.5 16.5s22.833 9 35.5 12 25.667 5.333 39 7c13.333 1.667 27.333 2.5 42 2.5 70.667 0 124-15 160-45l32 0C567 1009 620.333 1024 685 1024z" p-id="7035" fill="#5C5C5C"></path></svg></div>
						<div style="height: 30px;line-height: 30px;">547187319</div>
					</div>
					<div class="footcontentimg">
						<div><svg t="1606023685930" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4672" width="200" height="200"><path d="M256 512a64 64 0 1 1 0-128 64 64 0 0 1 0 128m256 0a64 64 0 1 1 0-128 64 64 0 0 1 0 128m256 0a64 64 0 1 1 0-128 64 64 0 0 1 0 128M512 64C264.576 64 64 235.904 64 448c0 130.112 75.776 244.928 191.232 314.368l-2.048 148.48 150.592-90.56C439.36 827.968 475.584 831.872 512 832c247.424 0 448-171.904 448-384S759.424 64 512 64m0 832a584.768 584.768 0 0 1-95.68-8.192L192 1024V797.44C75.008 715.328 0 589.44 0 448 0 200.576 229.248 0 512 0s512 200.576 512 448-229.248 448-512 448" p-id="4673" fill="#5C5C5C"></path></svg></div>
						<div style="height: 30px;line-height: 30px;">18618323019</div>
						<div><svg t="1606023742004" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="6145" width="200" height="200"><path d="M834.446 213.447H194.105c-50.176 0-91.022 40.846-91.022 91.022v423.026c0 50.176 40.846 91.022 91.022 91.022h640.341c50.176 0 91.022-40.846 91.022-91.022V304.469c0-50.176-40.846-91.022-91.022-91.022z m36.409 514.048c0 20.025-16.384 36.409-36.409 36.409H194.105c-20.025 0-36.409-16.384-36.409-36.409V304.469c0-20.025 16.384-36.409 36.409-36.409h640.341c20.025 0 36.409 16.384 36.409 36.409v423.026z" p-id="6146" fill="#5C5C5C"></path><path d="M786.773 358.059L514.275 529.977 241.777 358.059c-12.743-8.078-29.582-4.21-37.661 8.533-8.078 12.743-4.21 29.582 8.533 37.661l286.72 180.907c4.551 2.845 9.557 4.21 14.563 4.21h0.91c5.006 0 10.013-1.365 14.563-4.21l286.72-180.907c12.743-8.078 16.611-24.917 8.533-37.661-8.306-12.857-25.145-16.611-37.888-8.533z" p-id="6147" fill="#5C5C5C"></path></svg></div>
						<div style="height: 30px;line-height: 30px;">terry@bangweike.com</div>
					
					</div>
				</div>
				<div class="foot_mainDiv1">
					<div class="footBorder">
					产品<span>&nbsp;&nbsp;&nbsp;&nbsp;products</span>
					</div>
					<div class="footcontent">
						<a href="http://bwk.bytev.cn/html/productdetails.html#visualbjs" target="_blank">数据可视化</a>
					</div>
					<div class="footcontent" >
							<a href="http://bwk.bytev.cn/html/productdetails.html#protixi" target="_blank">数据采集</a>
					</div>
					<div class="footcontent">
						<a href="http://bwk.bytev.cn/html/productdetails.html#analyzes" target="_blank">数据分析</a>
					</div>
					<div class="footcontent">
						<a href="http://bwk.bytev.cn/html/productdetails.html#manages" target="_blank">数据资产管理</a>
					</div>
				</div>
				<div class="foot_mainDiv1">
					<div class="footBorder">
					关于我们<span>&nbsp;&nbsp;&nbsp;&nbsp;about us</span>
					</div>
					<div class="footcontentWechat">
						<div>
							<div class="footcontent">
								<a href="http://bwk.bytev.cn/html/all_content.html"  target="_blank">公司介绍</a>
								
								</div>
							<div class="footcontent" >官方微博</div>
							<div class="footcontent">
								<a href="http://bwk.bytev.cn/html/all_content.html#slide-two"  target="_blank">合作伙伴</a>
								</div>
						</div>
						
						<div><img src="../assets/images/qrcode.png" alt=""></div>
					</div>
						
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/bus.js'
	import '@/router/jquery-3.3.1.min.js'
	import rolling from '@/components/rolling.vue'
	export default{
		data (){
			return {
				apiUrl:this.apiUrl,
				banner:'',
				dgExpandedKeys:'',
				dgCheckedKeys:'',
				wdExpandedKeys:'',
				wdCheckedKeys:'',
				graphswipe:["../assets/images/detailsimg.png","../assets/images/detailsimg.png","../assets/images/detailsimg.png"]
			}
		},
		components:{
			rolling
		},
		methods:{
			downLoad(){
				this.$router.push('/down')
			},
			jumphelp(type){
				if(type == 1){
					  window.open('http://bytev.com.cn/index.php?app=shop','_blank')
				}else{
					  this.$router.push('/down')
				}
			},
			jumprepository(){
				this.$router.push('/repository')
			},
			jumpgrah(){
				this.$router.push('/graph')
			},
			jumpdemo(){
				this.$router.push('/demo')
			},
		},
		mounted(){
			this.$nextTick(function(){
				let demo=document.getElementById('demo');
				demo.className = 'el-menu-item'
				demo.style.color='rgb(255, 255, 255)';
				demo.style.borderBottomColor='transparent';
			});
			let _this=this;
			//获取数据
			this.$http.get(
				_this.apiUrl+'index.php? m=Api&c=Content&a=getIndexContent',
			).then(response => {
				
				//进行数据验证
				if(response.body.status != 1){
					
					//显示错误页面
					return;
				}
				
				if(typeof response.body.data == "undefined" || response.body.data == null || response.body.data == ""){
					
					//显示空数据页面
//					alert('没有数据');
					return;
				} 
				//banner图
//				this.$refs.homebannar.banner = response.body.data.advertList;
				this.banner=response.body.data.advertList;
				this.$refs.rolling.items=response.body.data.noticeList;
				this.$nextTick(function() {
					//轮播公告大于一条轮播
					if(response.body.data.noticeList.length>1){
						this.$refs.rolling.hover();
					}
					//轮播图背景设置cover属性
					$('.back').css('backgroundSize','cover')
				})
			}, response => {   
				
			});
			
		},
		created(){
			/*
			this.apiUrl = '';
			this.banner = [
				{
					id: "0",
					n_contenttype: "0",
					vc_content: "",
					vc_coverphoto: "./static/img/homebannerA.png",
				},
				{
					id: "1",
					n_contenttype: "1",
					vc_content: "",
					vc_coverphoto: "./static/img/homebannerB.png",
				},
				{
					id: "2",
					n_contenttype: "2",
					vc_content: "",
					vc_coverphoto: "./static/img/homebannerC.png",
				}
			];
			*/
		}
	}
</script>

<style>
	.back{
		background-size: cover
	}
	#testid{
		position: relative;
	}
	.home_box>.el-carousel>.el-carousel__container{
		background: url("./img/444444.png") no-repeat;
		background-size: 100% 100%;

		height: 969px;
	}
	.homebannerbg{
		height: 969px;
		width: 100%;
		display: block;
	}
	.wrapbox{
		overflow-x: hidden;
		width: 100%;
	}
	.home_box{
		position: relative;
		width: 100%;
		height: 100%;
		/*min-width: 1200px;*/
		max-height: 100%;
	}
	.home_box img{
		width: 100%;
	}
	
	.home_box>#homepage_download,.to_use{
		width: 10%;
		height: auto;
		display: block;
		position: absolute;
		top: 25%;
		bottom: 0;
		right: 0;
		left: 200px;
		margin: auto;
		z-index: 2;
	}
	.home_box>#homepage_download,.to_m{
		width: 10%;
		height: auto;
		display: block;
		position: absolute;
		top: 25%;
		bottom: 0;
		right: 0;
		left: -200px;
		margin: auto;
		z-index: 2;
	}
	.to_use{
		background: url(../assets/images/down.png) no-repeat;
		background-size: 100% 100%;
	    height: 70px;
	    font-size: 22px;
    	line-height: 58px;
    	color: #efefef;
    	font-weight: bold;
	}
		.to_m{
		background: url(../assets/images/down.png) no-repeat;
		background-size: 100% 100%;
	    height: 70px;
	    font-size: 22px;
    	line-height: 58px;
    	color: #efefef;
    	font-weight: bold;
	}
	.introduce{
		color: #efefef;
		position: absolute;
		top: 30%;
		z-index: 2;
		height: 15%;
		bottom: 0;
		right: 0;
		left: 0;
		font-size: 30px;
	}
	.contentbox1{
		border-top: solid 1px #F2F2F2;
		height: 759px;
		width: 100%;
		min-width: 1200px;
		/*background: #F2F2F2 url(../assets/images/head_lo.png) no-repeat center 90px;*/
		background: #F2F2F2;
	}
	.box1{
		width: 1200px;
		height: 300px;
		margin:230px auto;
		display: flex;
		justify-content: space-around;
	}
	.box1 .navlogo{
		height: 100%;
		width:220px ;
	}
	.box1 .navlogo img{
		display: block;
		margin-left: 74px
	}
	.box1 .navlogo h4{
		text-overflow:ellipsis;
		overflow: hidden;
		white-space: nowrap;
		color: #2E3A50;
		font-size: 20px;
		line-height: 60px;
	}
	.box1 .navlogo p{
		text-overflow:ellipsis;
		overflow: hidden;
		/* white-space: nowrap; */
		display: block;
		color: #949BA8;
	}
	.contentbox2{
		border-top: solid 1px #FFFFFF;
		height: 623px;
		width: 100%;
		min-width: 1200px;
		background: #FFFFFF;
	}
	.contentbox2 .knowmorebg{
		position: relative;
		top:-25% ;
		left: 0;
		right: 0;
		margin: auto;
	}
	.box2{
		position: relative;
		 -webkit-box-shadow: #F3F3F3 0px 4px 20px;
  		 -moz-box-shadow: #F3F3F3 0px 4px 20px;
  		 box-shadow: #F3F3F3 0px 4px 20px;
		width: 930px;
		height: 700px;
		background: #FFFFFF;
		margin:0 auto;
		top: -33%;
	}
	.box2 h3{
		line-height: 416.67%;
		font-size: 24px;
		color: #2F3A4F;
	}
	.box2 .demobox{
		margin: 0 auto;
		width: 86%;
		height: 60%;
		/*background: url(../assets/images/hometpk.jpg) no-repeat center;*/
		background: url(../assets/images/homeContentbox2.png) no-repeat center;
		background-size:100% 100%;
		-webkit-box-shadow: #F3F3F3 0px 4px 20px;
   		-moz-box-shadow: #F3F3F3 0px 4px 20px;
   		box-shadow: #F3F3F3 0px 4px 20px;
	}
	.left>.el-carousel>.el-carousel__container{
		background: url("http://e.hiphotos.baidu.com/image/pic/item/a1ec08fa513d2697e542494057fbb2fb4316d81e.jpg");
		height: 230px;
	}
	.knowmorebg{
		font-size: 16px;
		border-radius: 20px;
		width: 122px;
		height: 40px;
		line-height: 40px;
		color: white;
		cursor: pointer;
		background: #076bf2;
		/*background: -webkit-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -o-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: -moz-linear-gradient(30deg, #65d2ff , #076bf2); 
	    background: linear-gradient(30deg, #65d2ff , #076bf2);*/
	}
	.box2 ul{
		margin-left: 15%;
		margin-top: 8%;
		height: 10%;
		width: 70%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.box2 ul li{
		font-size: 14px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow:ellipsis;
		width: 33%;
		height: 30px;
		line-height: 30px;
		background-size: 20px;
		text-align: left;
		text-indent: 30px;
		background:url(../assets/images/listimg.png) no-repeat left center;
	}
	.contentbox3{
		border-top: 1px solid #F2F2F2;
		width: 100%;
		height: 566px;
		min-width: 1200px;
		background: #F2F2F2;
	}
	.box3{
		position: relative;
		width: 1200px;
		height: 320px;
		margin: 0 auto;
		top: 21.73%;
	}
	.box3 .left{
		float: left;
		width: 60%;
	}
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 200px;
		margin: 0;
	}
	.box3 .right{
		width: 30%;
		float: left;
		margin-left: 8%;		
	}
	.box3 .right h3{
		margin-top: 20px;
		text-align: left;
		font-size: 24px;
		margin-bottom: 20px;
	}
	.box3 .right ul{
		text-align: left;
		font-size: 14px;
	}
	.box3 .right ul li{
		overflow: hidden;
		white-space: nowrap;
		text-overflow:ellipsis;
		height: 48px;
		line-height: 48px;
		background:url(../assets/images/listimg.png) no-repeat left center;
		background-size: 20px 20px;
		text-indent: 30px;
	}
	.box3 .right img{
		margin-top: 20px;
		display: block;
	}
	.box3 .left img{
		display: block;
		width: 100%;
		height: 100%;
	}
	.contentbox4{
		border-top: solid 1px #FFFFFF;
		height: 1300px;
		width: 100%;
		min-width: 1200px;
		background: #FFFFFF url(../assets/images/bottombg.png) no-repeat center bottom;
		background-size: 100% 571px;
	}
	.fourtop{
		margin: 150px auto;
		height: 364px;
		width: 1200px;
	}
	.fourtop .left{
		background: url(../assets/images/circlebg.png) no-repeat left center;
		float: left;
		width: 473px;
		height:364px;
		background-size: 473px 364px;
	}
	.fourtop .right{
		margin-top:-30px ;
		float: right;
		width: 50%;
		height:100% ;
		box-shadow: 4px 4px 3px 3px #F3F3F3;
		/*background: url(../assets/images/homezsk.png) no-repeat center;*/
		background: url(../assets/images/bjb.png) no-repeat center;
		background-size: 100% 100%;
	}
	.fourtop h3{
		margin-top: 10px;
		line-height: 300%;
		text-align: left;
		font-size: 24px;
		margin-left: 50px;
	}
	.fourtop ul{
		font-size: 14px;
		color: #2F3A4F;
		text-align: left;
		margin-left: 50px;
	}
	.fourtop ul li{
		/* overflow: hidden; */
		white-space: nowrap;
		text-overflow:ellipsis;
		height: 42px;
		line-height: 42px;
		text-indent: 30px;
		background-size: 20px 20px;
		background: url(../assets/images/listimg.png) no-repeat left center;
	}
	.box4 .fourtop .left .knowmorebg{
		margin: 28px 0 0 50px;
	}
	.box3 .right .knowmorebg{
		margin: 28px 0 0 0;
	}
	.bottomnavbox{
		width: 1200px;
		height: 350px;
		margin:0 auto;
		margin-top: 190px;
		display: flex;
		justify-content: space-around;
	}
	.box4 .bottomnavbox .navlogo{
		width: 350px;
	}
	.box4 .bottomnavbox .navlogo .logobottom{
		width: 350px;
		height:179px ;
		background: url(../assets/images/wrapcircle.png) no-repeat center;
		background-size: 179px 179px ;
		display: flex;
		justify-content: center;
		align-items:center;
	}
	.box4 .bottomnavbox .navlogo .logobottom>img{
		display: block;
		width:95px ;
		height: 95px;
	}
	.box4 .bottomnavbox .navlogo>h4{
		width: 350px;
		text-overflow:ellipsis;
		overflow: hidden;
		white-space: nowrap;
		color: #242424;
		font-size: 20px;
		line-height: 60px;
	}
	.box4 .bottomnavbox .navlogo p{
		color: #707477;
		line-height: 30px;
		height: 30px;
		/*text-align: left;*/
		/*text-indent: 12px;*/
		font-size: 14px;
		overflow: hidden;
		height: 80px;
	}
	.box1>.navlogo>img{
		height: 133px;
		width: 152px;
	}
	.bottomnavbox>.navlogo>img{
		height: 35px;
		width: 122px;
	}
	.foot_main{
		background: #171717;
		width: 100%;
		height: 350px;
	}
	.foot_mainDiv{

		width: 1200px;
		color: #FFFFFF;
		font-size: 20px;
		padding-top: 40px;
		margin: 0 auto;
		display: grid;
		grid-template-columns: 550px 550px 550px;
	}
	.footBorder{
		border-bottom: 1px solid #4b4b4b;
		width: 300px;
		padding-bottom: 15px;
		margin-bottom: 50px;
	}
	.foot_mainDiv1{
		text-align: left;
	}
	.foot_mainDiv1>div>span{
		color: #4b4b4b;
	}
	.footcontent,.footcontent>a{
		margin-bottom: 20px;
		color: #4b4b4b;
		font-size: 17px;
	}
	/* .footconnentImg{
		width: 100px;
		height: 100px;
	} */
	.footcontent>a:hover{
		color: #2461B4;
	}
	.footcontentimg{
		margin-bottom: 20px;
		font-size: 17px;
		color: #5C5C5C;
		display: grid;
		grid-template-columns: 35px 185px 42px 91px;
	}
	.icon{
		width: 30px;
		height: 30px;
	}
	.footcontentWechat{
		display: grid;
		grid-template-columns: 100px 100px;
	}
</style>


// WEBPACK FOOTER //
// src/views/homePage.vue